export default "__VITE_PUBLIC_ASSET__df8a2c9c__"